<template>
  <v-card outlined class="rounded-lg">
    <v-card-title class="primary--text">
      <v-icon left color="primary">fal fa-calculator</v-icon>
      {{ $t("weighted_average_cost") }}
    </v-card-title>

    <v-card-text>
      <div>
        <p class="text-body-2 mb-3">
          {{ $t("weighted_average_description") }}
        </p>
        <v-alert dense type="info" class="mb-4">
          {{ $t("lak_explainer") }}
        </v-alert>

        <v-sheet outlined rounded class="pa-4 mb-4">
          <div class="text-subtitle-2 primary--text font-weight-medium mb-2">
            {{ $t("calculation_formula") }}:
          </div>
          <div class="font-monospace body-2">
            <strong>
              {{ $t("new_average") }} = ({{ $t("old_stock") }} ×
              {{ $t("old_price") }} + {{ $t("new_stock") }} ×
              {{ $t("new_price") }}) ÷ {{ $t("total_stock") }}
            </strong>
          </div>
        </v-sheet>

        <div class="example-section">
          <div class="example-title">{{ $t("example") }}:</div>
          <v-row>
            <v-col cols="12" md="6">
              <v-sheet outlined rounded class="pa-4">
                <div
                  class="text-subtitle-2 primary--text font-weight-medium mb-2"
                >
                  {{ $t("initial_stock") }}
                </div>
                <div>
                  <div class="d-flex align-center justify-space-between py-1">
                    <span class="caption text--secondary"
                      >{{ $t("quantity") }}:</span
                    >
                    <span class="font-weight-medium">10 {{ $t("units") }}</span>
                  </div>
                  <div class="d-flex align-center justify-space-between py-1">
                    <span class="caption text--secondary"
                      >{{ $t("price") }}:</span
                    >
                    <span class="font-weight-medium"
                      >₭50,000 {{ $t("each_label") }}</span
                    >
                  </div>
                  <div class="d-flex align-center justify-space-between py-1">
                    <span class="caption text--secondary"
                      >{{ $t("total_value") }}:</span
                    >
                    <span class="font-weight-medium">₭500,000</span>
                  </div>
                </div>
              </v-sheet>
            </v-col>

            <v-col cols="12" md="6">
              <v-sheet outlined rounded class="pa-4">
                <div
                  class="text-subtitle-2 primary--text font-weight-medium mb-2"
                >
                  {{ $t("new_stock") }}
                </div>
                <div>
                  <div class="d-flex align-center justify-space-between py-1">
                    <span class="caption text--secondary"
                      >{{ $t("quantity") }}:</span
                    >
                    <span class="font-weight-medium">5 {{ $t("units") }}</span>
                  </div>
                  <div class="d-flex align-center justify-space-between py-1">
                    <span class="caption text--secondary"
                      >{{ $t("price") }}:</span
                    >
                    <span class="font-weight-medium"
                      >₭80,000 {{ $t("each_label") }}</span
                    >
                  </div>
                  <div class="d-flex align-center justify-space-between py-1">
                    <span class="caption text--secondary"
                      >{{ $t("total_value") }}:</span
                    >
                    <span class="font-weight-medium">₭400,000</span>
                  </div>
                </div>
              </v-sheet>
            </v-col>
          </v-row>

          <v-sheet outlined rounded class="pa-4">
            <div class="text-subtitle-2 primary--text font-weight-medium mb-2">
              {{ $t("calculation") }}:
            </div>
            <div class="d-flex flex-column font-monospace body-2">
              <span class="py-1">(10 × ₭50,000 + 5 × ₭80,000) ÷ 15</span>
              <span class="py-1">= (₭500,000 + ₭400,000) ÷ 15</span>
              <span class="py-1">= ₭900,000 ÷ 15</span>
              <span class="py-1 font-weight-medium primary--text"
                >= ₭60,000 {{ $t("per_unit_label") }}</span
              >
            </div>
          </v-sheet>
        </div>

        <v-alert type="info" outlined class="mt-4">
          <div class="alert-content">
            <strong>{{ $t("note") }}:</strong> {{ $t("weighted_average_note") }}
          </div>
        </v-alert>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "WeightedAverageInfo",
  props: {
    showExample: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped></style>
